<template>
  <div ref="madeForm">
    <div class="title">检查概览</div>
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <div class="title">检查项执行</div>
    <FormTable ref="formTable" :formData="formData" :optionConfig="optionConfig" />
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
    <SelectCheckList ref="selectCheckList" @replace="replace"></SelectCheckList>
  </div>
</template>

<script>
import { add, update, getDetail, getUserList } from "../api";
import { getDetail as getCheckDetail } from "@/views/dispatch-manage/check-list/api.js";
import _ from 'lodash'
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';
import SelectCheckList from './select-check-list.vue';

export default {
  components: { SelectCheckList },
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      userList: [],
      formData: {
        list: []
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        labelWidth: 150,
        span: 12,
        addText: '新增检查项',
        column: [
          {
            label: "关联检查计划",
            prop: "planName",
            readonly: true,
            click: () => {
              this.$refs.selectCheckList.open()
            },
          },
          {
            label: "检查类型",
            prop: "checkType",
            dicUrl: '/api/produce/safey-type/select/querySafeyType?safeyType=1',
            dataType: 'string',
            type: "select",
            cascader: ['checkItemId'],
            props: {
              label: "typeName",
              value: "typeCode"
            },
            rules: rulesInput(2),
          },
          {
            label: "受检对象",
            prop: "checkAreaCode",
            multiple: true,
            dicUrl: '/api/produce/safey-type/select/querySafeyType?safeyType=2',
            dataType: 'string',
            type: "select",
            props: {
              label: "typeName",
              value: "typeCode"
            },
            rules: rulesInput(2),
            change: ({ value }) => {
              const { DIC } = this.$refs.form;
              if (!DIC.checkAreaCode) return
              // 处理value为数组或逗号分隔字符串的情况
              const codes = Array.isArray(value)
                ? value
                : (typeof value === 'string' ? value.split(',').map(v => v.trim()) : [value]);
              // 筛选并拼接名称
              this.formData.checkAreaName = DIC.checkAreaCode
                .filter(item => codes.some(c => String(c) === String(item.typeCode)))
                .map(item => item.typeName)
                .join(',');
            }
          },
          {
            label: "检查日期",
            prop: "checkDate",
            type: 'date',
            rules: rulesInput(2),
          },
          {
            label: "检查人员",
            prop: "inspectorIds",
            dataType: 'string',
            type: "select",
            multiple: true,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
            rules: rulesInput(2),
          },
          {
            label: "验收人员",
            prop: "acceptPersonId",
            dataType: 'string',
            type: "select",
            multiple: true,
            dicData: [],
            rules: rulesInput(2),
            props: {
              label: "name",
              value: "id"
            },
          },
          {
            label: "关联检查表",
            prop: "checkItemId",
            overHidden: true,
            rules: rulesInput(2),
            props: {
              label: "checkListName",
              value: "id"
            },
            dataType: 'string',
            type: "select",
            dicUrl: '/api/produce/safety-check-list/select/queryCheckListByType?checkType={{checkType}}',
            change: ({ value }) => {
              if (value) {
                setTimeout(() => {
                  const { DIC } = this.$refs.form
                  const item = _.find(DIC.checkItemId, { id: value })
                  this.replaceCheckList(item)
                }, 1000);
              } else {
                this.$set(this.formData, 'list', [])
              }
            }
          },
          {
            label: "检查备注",
            prop: "remark",
            type: "textarea",
            hide: true,
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 3,
            overHidden: true,
          },
        ]
      },
      list: [],
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: false,
        delBtn: false,
        align: 'center',
        height: '40vh',
        column: [
          {
            label: '检查项目',
            prop: 'itemName',
            required: true,
            disabled: true,
          },
          {
            label: '检查标准',
            prop: 'checkListStandard',
            precision: 2,
            required: true,
            disabled: true,
          },
          {
            label: '检查结果',
            prop: 'checkResult',
            required: true,
            dicData: this.$store.getters.commonDict['area_name'],
            type: "select",
          },
          {
            label: '现场照片',
            prop: 'checkPhotos',
            type: 'updata-img',
            url: '/api/produce/file-upload/uploadCheckPhoto'
          },
          {
            label: "问题描述",
            prop: "problemDescription",
            type: 'textarea',
            maxlength: 200,
            // required: true,
            span: 24,
            minRows: 3,
          },
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { type, id } = this.transmitData
      type !== 'add' && this.getDetail(id)
      // 获取人员
      getUserList().then(({ data }) => {
        this.userList = data
        this.findObject(this.optionForm.column, 'acceptPersonId').dicData = data
        this.findObject(this.optionForm.column, 'inspectorIds').dicData = data
      })
    },
    //提交
    async submitForm () {
      const list = this.formData.list
      const { type } = this.transmitData
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate) {
          if (type == 'add') {
            add(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          } else {
            update(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
        this.isDetails() && disposeDetail(topTier, 'table-details')
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    //带出检查项
    replaceCheckList (item) {
      this.$set(this.formData, 'list', item.list)
      item.list.forEach((ls) => {
        ls.checkListId = ls.id
      })
      console.log(item.list, 'item.list1111');
    },
    replace (row) {
      const replaceKey = ['planNumber', 'planName', 'checkType']
      this.$set(this.formData, 'planId', row.id)
      this.$set(this.formData, 'acceptPersonId', row.responsiblePersonId)
      this.$set(this.formData, 'checkItemId', row.checkListId)
      this.$set(this.formData, 'checkAreaCode', row.areaCode)
      this.$set(this.formData, 'checkAreaName', row.areaName)
      this.$set(this.formData, 'responsibleDeptId', row.responsibleDeptId)
      this.$set(this.formData, 'responsibleDeptName', row.responsibleDeptName)
      this.$set(this.formData, 'responsiblePersonId', row.responsiblePersonId)
      this.$set(this.formData, 'responsiblePersonName', row.responsiblePersonName)
      this.$set(this.formData, 'acceptPersonName', row.responsiblePersonName)
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    },
  }
}
</script>
<style scoped lang="scss">
.title {
  margin: 10px 0;
  font-size: 20px;
  color: #363636;
}
</style>
